














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Schedule    from '../model/Schedule';
import Session     from '../model/Session';
import Participant from '../model/Participant';
import Options     from '../model/Options';

@Component
export default class ComplaintPairs extends Vue {
  @Prop() private schedule!: Schedule;
  @Prop() private options!: Options;
}
